import { createSlice } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
const BUILD_NUMBER = process.env.REACT_APP_BUILD_NUMBER;

const initialState = {
  data: [],
  vehicleLoading: false,
  loadingMore: false,
  moreDataAvailable: true,
  currentPage: 0,
  filterData: "",
  vehicleNumber: "",
};

const vehicleSlice = createSlice({
  name: "vehicle",
  initialState,
  reducers: {
    setFilterData(state, action) {
      state.filterData = action?.payload;
    },
    getList(state, _) {
      state.vehicleLoading = true;
    },
    getListSuccess(state, { payload }) {
      const { message, data = [] } = payload;
      //   toast.success(message);
      state.vehicleLoading = false;
      state.data = data;
      if (data.length === 10) {
        state.moreDataAvailable = true;
      } else {
        state.moreDataAvailable = false;
      }
      state.currentPage = 1;
    },
    handleNextPage(state, { payload }) {
      const { currentPage, moreDataAvailable } = payload;
      // state.isFilterButtonClicked=true;
      state.data = [];
      state.moreDataAvailable = true;
      state.currentPage = 1;
    },
    getListError(state, { payload }) {
      console.log("inside error reducer");
      const { message = "Something went wrong." } = payload;
      //toast.error(message);
      state.data = [];
      state.vehicleLoading = false;
    },
    loadMore(state, _) {
      state.loadingMore = true;
    },
    addMoreNewData(state, { payload }) {
      state.data = payload;
    },
    loadMoreSuccess(state, { payload }) {
      const { message, data = [] } = payload;
      //   toast.success(message);
      state.loadingMore = false;
      if (data.length === 10) {
        state.moreDataAvailable = true;
      } else {
        state.moreDataAvailable = false;
      }
      state.data = [...state.data, ...data];
      state.currentPage += 1;
    },
    loadMoreError(state, { payload }) {
      console.log("inside error reducer");
      const { message = "Something went wrong." } = payload;
      //toast.error(message);
      // state.data = [];
      state.loadingMore = false;
    },
    setSearch(state, { payload }) {
      const { vehicleNumber = "" } = payload;
      state.vehicleNumber = vehicleNumber;
    },
    setVehicle(state, action) {
      state.vehicleId = action.payload;
    },
    setMoreDataAvilable(state) {
      state.moreDataAvailable = true;
    },
    setListPageNo(state, action) {
      state.pageNumber = action.payload;
    },
  },
  extraReducers: {},
});

export const {
  getList,
  getListSuccess,
  getListError,
  loadMore,
  setVehicle,
  loadMoreError,
  loadMoreSuccess,
  setSearch,
  setListPageNo,
  addMoreNewData,
  setFilterData,
  setMoreDataAvilable,
  handleNextPage,
} = vehicleSlice.actions;

// selectors
export const getfilterData = (state) => state.vehicle.filterData;
export const selectVehicleLoading = (state) => state.vehicle.vehicleLoading;
export const selectVehicleData = (state) => state.vehicle.data;

export const selectCurrentPage = (state) => state.vehicle.currentPage;
export const selectMoreDataAvailable = (state) =>
  state.vehicle.moreDataAvailable;
export const selectLoadingMore = (state) => state.vehicle.loadingMore;
export const selectVehicleNumber = (state) => state.vehicle.vehicleNumber;

export default vehicleSlice.reducer;
